module.exports = __webpack_public_path__ + "img/banner.4a13f19b.png";